import React, {useState} from 'react';
import classnames from 'classnames';

import {LoadingSpinner, TabNavigation, Wall} from '@albert-io/atomic';

import IndiePracticeViewer from './IndiePractice/IndiePracticeViewer.react';
import ClassroomMenu from './ClassroomMenu/ClassroomMenu.react';
import AssignmentsList from './AssignmentsList/AssignmentsList.react';

import {useStudentDashboard} from './StudentDashboard.context';

import './student-dashboard.scss';

const StudentDashboard = () => {
  const {assignments, classrooms, student, invitations, isReady} = useStudentDashboard();
  const [activeTab, setActiveTab] = useState('classes');
  const hasNoClassrooms = classrooms.isEmpty();

  return (
    <div className='student-dashboard'>
      {isReady ? (
        <>
          <Wall title={<Wall.Title as='h1'>{student.getFullName()}</Wall.Title>} />
          <TabNavigation
            as='ul'
            className='u-list-style_none u-pad_0 u-width_100pc u-overflow_hidden u-max-width_default student-dashboard__tabs'
            paddingLevel={0}
            role='tablist'
          >
            <TabNavigation.Tab
              as='li'
              className={classnames('u-display_flex student-dashboard__tabs__tab', {
                'student-dashboard__tabs__tab--inactive': activeTab !== 'classes'
              })}
              isActive={activeTab === 'classes'}
              role='presentation'
            >
              <a
                aria-selected={activeTab === 'classes'}
                className={classnames('u-text-decoration_none u-pad-tb_3 u-pad-lr_2', {
                  'u-color_blue-400': activeTab === 'classes'
                })}
                href='#classes'
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab('classes');
                }}
                role='tab'
              >
                Classes
              </a>
            </TabNavigation.Tab>
            <TabNavigation.Tab
              as='li'
              className={classnames('u-display_flex student-dashboard__tabs__tab', {
                'student-dashboard__tabs__tab--inactive': activeTab !== 'practice'
              })}
              isActive={activeTab === 'practice'}
              role='presentation'
            >
              <a
                aria-selected={activeTab === 'practice'}
                className={classnames('u-text-decoration_none u-pad-tb_3 u-pad-lr_2', {
                  'u-color_blue-400': activeTab === 'practice'
                })}
                href='#practice'
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab('practice');
                }}
                role='tab'
              >
                Practice
              </a>
            </TabNavigation.Tab>
          </TabNavigation>
          <div
            className={classnames('student-dashboard__inner', {
              'student-dashboard__inner--empty': hasNoClassrooms
            })}
          >
            <AssignmentsList
              className={classnames('student-dashboard__aside', {
                'student-dashboard__aside--empty': hasNoClassrooms,
                'student-dashboard__hidden-element': activeTab === 'practice',
                'student-dashboard__aside--with-overlay': !assignments.isEmpty()
              })}
              assignments={assignments}
              studentId={student.getId()}
            />
            <ClassroomMenu
              className={classnames('student-dashboard__main', {
                'student-dashboard__hidden-element': activeTab === 'practice'
              })}
              classrooms={classrooms}
              invitations={invitations}
              student={student}
            />
            {hasNoClassrooms ? null : (
              <IndiePracticeViewer
                className={classnames('student-dashboard__footer u-max-width_default', {
                  'student-dashboard__hidden-element': activeTab === 'classes'
                })}
              />
            )}
          </div>
        </>
      ) : (
        <LoadingSpinner className='u-pad-t_10' size={3} />
      )}
    </div>
  );
};

export default StudentDashboard;
